// src/Modules/Listing/ListingAPI.js
import apiService from '../../Services/APIService';
import { checkAPIResponse } from '../../Utils/APIResponseUtils';

/**
 * Fetch agencies list matching filter criteria from SahiCRM API
 * @param {Object} params Filter parameters
 * @returns {Promise<Array>} List of agency listing records
 */
export const getListingAgenciesAPI = async ({
  industryID = 0,
  segmentID = 0,
  stateID = 0
} = {}) => {
  try {
    const payload = [
      {
        industryID: Number(industryID) || 0,
        segmentID: Number(segmentID) || 0,
        stateID: Number(stateID) || 0
      }
    ];

    const result = await apiService.getData(16, 'b2b_GetListing', payload);
    checkAPIResponse(result);

    if (result?.updatePackage) {
      const parsed = typeof result.updatePackage === 'string'
        ? JSON.parse(result.updatePackage)
        : result.updatePackage;

      // Table1 contains the query result set from DataSet (Table0 is FnResult)
      if (parsed?.Table1) {
        return parsed.Table1;
      }

      // Fallback if returned in Table
      if (parsed?.Table && Array.isArray(parsed.Table) && parsed.Table[0]?.AgencyID) {
        return parsed.Table;
      }
    }

    return [];
  } catch (error) {
    console.error('Listing API Error:', error);
    throw error;
  }
};
